module.exports = __webpack_public_path__ + "img/img_Colleges15.80100298.jpg";